<template>
  <el-main style="padding: 0; overflow: hidden;">
    <!-- <div>
      <el-button-group class="home-button-group">
        <el-button type="primary" plain @click="clickDetail" size="mini">详情</el-button>
         -->
        <!-- 宜春消防 -->
         <!-- <el-button type="primary" plain @click="clickTracePJ" size="mini">快捷派警</el-button>
        <el-button type="primary" plain @click="clickNotify" size="mini">通知</el-button>
        <el-button type="primary" plain @click="clickStatis" size="mini">到场统计</el-button>
        <el-button type="primary" plain @click="clickTrace" size="mini">轨迹</el-button> -->
        
        <el-select v-model="selectAdminId" @change="changeSelectAdminId"
        size="mini" style="padding-right: 1px; width: 160px;" placeholder="管辖人(消防站)">
      <el-option v-for="item in adminTypes" :key="item.userId" :label="item.userName" :value="item.userId"/>
    </el-select>
        <el-button type="primary" style="margin-left: 5px;" plain @click="clickUnitQuery" size="mini">查询水源</el-button>
        <el-button type="primary" v-if="this.$store.getters.loginInfo.roleId <=3 && clearFenceBtn"  plain @click="clearFence" size="mini">取消</el-button>
        <el-button type="primary"   plain v-if="showImg" @click="showWaterImg(true)" size="mini">显示水源图层</el-button>
        <el-button type="primary"   plain v-else @click="showWaterImg(false)" size="mini">隐藏图层(操作卡顿提高性能)</el-button>
        <el-button type="primary" v-if="this.$store.getters.loginInfo.roleId <=3 && !clearFenceBtn"  plain @click="showFenceTable = true" size="mini">绘制区域</el-button>
        <!-- <el-button type="primary" v-if="this.$store.getters.loginInfo.roleId <=3" plain @click="changeLocation" size="mini">{{btnLocations[btnIndex]}}</el-button> -->
    
        <span style="display: inline-block; margin-right: 10px;">
        <span style="
        display: inline-block;
        width: 12px;
        height: 12px;
        background-color: #FF00FF;
        border-radius: 50%;
        margin-left: 15px;
        vertical-align: middle;
    "></span>
        <span style="vertical-align: middle;">特勤站</span>
    </span>
   <span style="display: inline-block; margin-right: 10px;">
        <span style="
        display: inline-block;
        width: 12px;
        height: 12px;
        background-color: #13227A;
        border-radius: 50%;
        margin-left: 15px;
        vertical-align: middle;
    "></span>
        <span style="vertical-align: middle;">白马井站</span>
    </span>
   <span style="display: inline-block; margin-right: 10px;">
        <span style="
        display: inline-block;
        width: 12px;
        height: 12px;
        background-color: #1AFA29;
        border-radius: 50%;
        margin-left: 15px;
        vertical-align: middle;
    "></span>
        <span style="vertical-align: middle;">云月路站</span>
    </span>
   <span style="display: inline-block; margin-right: 10px;">
        <span style="
        display: inline-block;
        width: 12px;
        height: 12px;
        background-color: #2C2C2C;
        border-radius: 50%;
        margin-left: 15px;
        vertical-align: middle;
    "></span>
        <span style="vertical-align: middle;">海花岛站</span>
    </span>
   <span style="display: inline-block; margin-right: 10px;">
        <span style="
        display: inline-block;
        width: 12px;
        height: 12px;
        background-color: #FF7F50;
        border-radius: 50%;
        margin-left: 15px;
        vertical-align: middle;
    "></span>
        <span style="vertical-align: middle;">伏波站</span>
    </span>
   <span style="display: inline-block; margin-right: 10px;">
        <span style="
        display: inline-block;
        width: 12px;
        height: 12px;
        background-color: #D81E06;
        border-radius: 50%;
        margin-left: 15px;
        vertical-align: middle;
    "></span>
        <span style="vertical-align: middle;">其他</span>
    </span>
   <span style="display: inline-block; margin-right: 10px;">
        <span style="
        display: inline-block;
        width: 12px;
        height: 12px;
        background-color: #FF99FF;
        border-radius: 50%;
        margin-left: 15px;
        vertical-align: middle;
    "></span>
        <span style="vertical-align: middle;">故障-特勤站</span>
    </span>
   <span style="display: inline-block; margin-right: 10px;">
        <span style="
        display: inline-block;
        width: 12px;
        height: 12px;
        background-color: #CCFF00;
        border-radius: 50%;
        margin-left: 15px;
        vertical-align: middle;
    "></span>
        <span style="vertical-align: middle;">故障-白马井站</span>
    </span>
   <span style="display: inline-block; margin-right: 10px;">
        <span style="
        display: inline-block;
        width: 12px;
        height: 12px;
        background-color: #9ACD32;
        border-radius: 50%;
        margin-left: 15px;
        vertical-align: middle;
    "></span>
        <span style="vertical-align: middle;">故障-云月路站</span>
    </span>
   <span style="display: inline-block; margin-right: 10px;">
        <span style="
        display: inline-block;
        width: 12px;
        height: 12px;
        background-color: #B38B00;
        border-radius: 50%;
        margin-left: 15px;
        vertical-align: middle;
    "></span>
        <span style="vertical-align: middle;">故障-海花岛站</span>
    </span>
   <span style="display: inline-block; margin-right: 10px;">
        <span style="
        display: inline-block;
        width: 12px;
        height: 12px;
        background-color: #FFC145;
        border-radius: 50%;
        margin-left: 15px;
        vertical-align: middle;
    "></span>
        <span style="vertical-align: middle;">故障-伏波站</span>
    </span>
    <span style="display: inline-block;">
        <span style="
        display: inline-block;
        width: 12px;
        height: 12px;
        background-color: #0086F1;
        border-radius: 50%;
        margin-left: 15px;
        vertical-align: middle;
    "></span>
        <span style="vertical-align: middle;font-size: 16px;">天然水源</span>
    </span>
    <MapView :height="height" :scale="scale" :longitude="longitude" :latitude="latitude"
      :flag="alert" @add-fence="addFence" @on-location="onLocation" @on-fence="onFence" :city="city" ref="map"/>

      <el-dialog
      title="选择绘制管辖单位"
      :visible.sync="showFenceTable"
      width="30%"
      :model="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      :before-close="handleCloseUnitFenceTable">
      <span>
        <el-input v-model="searchRankUnitName" placeholder="搜索单位名称" style="width: 200px" size="mini"/>
        
        <el-button type="primary" plain icon="el-icon-search" @click="searchRankUnits" :loading="loading" size="mini"/>
        <p></p>
        <el-select v-model="unitFenceId" placeholder="选择单位" style="width: 100%">
          <el-option v-for="item in rankUnits" :key="item.unitId" :label="item.unitName" :value="item.unitId"/>
        </el-select>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showFenceTable = false">取 消</el-button>
        <el-button type="primary" @click="drawUnitFence">确 定</el-button>
      </span>
    </el-dialog>


    <!-- 查询单位信息弹出层 -->
    <el-dialog title="水源查询" :visible.sync="showUnit" append-to-body>
      <div class='div-row'>
        <span style="padding-right: 10px;">搜索水源</span>
        <el-input v-model="unitQ" size="mini" style="width: 160px"/>
        <el-button type="primary" icon="el-icon-search" @click="clickSearchUnits" :loading="loading" size="mini"/>
      </div>
      <el-table :data="searchUnits" border style="width: 100%" height="300">
        <el-table-column label="名称(编号)">
          <template slot-scope="scope">
            <el-button type="text" @click="locationUnit(scope.row)">{{scope.row.waterSourceName}}({{scope.row.waterNum}})</el-button>
          </template>
        </el-table-column>
        <el-table-column label="所属路段" prop="streetInfoName">
        </el-table-column>
        <el-table-column label="位置" prop="location">
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 查询轨迹信息弹出层 -->
    <!--<el-dialog title="轨迹查询" :visible.sync="showTrace" append-to-body width="400px">
      <div class='div-row'>
        <el-checkbox v-model="online" @change="onlineChange">只看在线用户</el-checkbox>
      </div>
      <el-tree ref="tree" :props="traceProps" :load="loadTrace" :data='traceUnits' @node-click="nodeClick" lazy> </el-tree>
    </el-dialog> -->

    <!-- 调度弹出层 -->
    <!--
    <el-dialog title="终端调度" :visible.sync="showTerm" append-to-body>
      <el-table :data="termUsers" border style="width: 100%" height="300">
        <el-table-column prop="userName" label="用户名" width="150"/>
        <el-table-column prop="mobile" label="手机号" width="100"/>
        <el-table-column prop="unitName" label="单位"/>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" @click="notifyTerm(scope.row.userId)" size="mini" :loading="loading" v-if="!scope.row.notifyConfirmTime">通知</el-button>
            <span v-if="scope.row.notifyConfirmTime">{{scope.row.notifyConfirmTime}}</span>
          </template>
        </el-table-column>>
      </el-table>
    </el-dialog>
    -->
  </el-main>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .circle {
    width: 16px; /* 圆的直径 */
    height: 16px; /* 圆的直径 */
    background-color: #3498db; /* 圆的颜色 */
    border-radius: 50%; /* 关键属性，使元素成为圆形 */
  }
</style>
<style> 

  .home-select-div .el-input__inner {
    color: #FF7043;
    background-color: #F5F5F5;
  }
    #container {
            position: absolute;
            top: 200px;
            left: 0;
            right: 0;
            margin: 0 auto;
            width: 600px;
            height: 300px;
            text-align: center;
        }
  .select-box {
            width: 300px;
            height: 31px;
            padding-left: 20px;
            font-size: 18px;
        }
 
        .input-box {
            position: absolute;
            margin-left: -300px;
            box-sizing: border-box;
            border: 1px solid #9e9e9e;
            border-right: none;
            width: 268px;
            height: 31px;
           
            padding-left: 23px;
            font-size: 18px;
        }
</style>
<style scoped lang="scss">
  $header-width: 467px;
  //$header-width: 385px + 80px;

  .home-select-div {
    margin-right: $header-width;
    padding-right: 1px;
  }
  .home-button-group {
    width: $header-width;
    float: right;
  }

  $mytable-border-color: #BDBDBD;
  .mytable td {
    border-bottom: 1px solid $mytable-border-color;
    padding: 10px;
  }
  .mytable td.label {
    font-weight: bold;
    width: 60px;
  }
  .div-row {
    border-bottom: 1px solid $mytable-border-color;
    padding: 10px 0;
    text-align: center;
  }
  
 
</style>
<style lang="scss">
    .el-tree-node {
         .is-leaf + .el-checkbox .el-checkbox__inner {
            display: inline-block;
          }
          .el-checkbox .el-checkbox__inner {
            display: none;
          }
        }
</style>

<script>
  import MapView from '@/components/map'
  import UserApi from '@/api/user'
  import UnitApi from '@/api/unit'
  import UnitFenceApi from '@/api/unitFence'
  import WaterSourceApi from '@/api/waterSource'
  import AppConfig from '@/config/app-config'
  import Utils from '@/utils/utils'
  import ws from '@/utils/ws'

  export default {
    
inject: ['reload'],
    components: {
      MapView
    },
    data() { 
    
      return {
      selectAdminId: '',
      adminTypes: [],
      showImg: false,
      clearFenceBtn: false,
      unitFenceId: '',
      showFenceTable: false,
      unitFences: [],
      rankUnits: [],
      btnLocations: ['人工定位', '完成定位'],
      searchUserTypes: ['附近用户', 'PC终端', '站长', '单位用户'],
      height: 0,
      scale: 16,
      // longitude: 110.298138,
      // latitude: 20.025386,
      // city: '宜春市', 
      longitude: 110.375309, 
      latitude: 20.019958, 
      city: '海口市', 
      /* alert: {}, 
      alerts: [], */
      location: false, 
      btnIndex: 0,
      units: [],
      waterSources: [],
      
      showDetail: false, detailItem: {},
 
     
      showNotify: false,loading: false, notifyRadius: 0.5, persons: [], selectPersons: [],
      
      showNotifyPJ: false,loading: false, notifyRadius: 0.5, persons: [], selectPersonsPJ: [],
    
      showStatis: false, presents: [],

   
      showUnit: false, unitQ: undefined, searchUnits: [],

  
      showTrace: false, online: false, traceUnits: undefined,
      showTracePJ:false, 
      traceProps: { label: 'name', children: 'children', isLeaf: 'leaf' },
      query: {},
     
        selectValue: 0.5,
        options: [{
            value: 0.5,
            text: "0.5"
        },{
            value: 1,
            text: "1"
        },{
            value: 1.5,
            text: "1.5"
        },{
            value: 2,
            text: "2"
        },{
            value: 2.5,
            text: "2.5"
        }, {
            value: 3,
            text: "3"
        },{
            value: 3.5,
            text: "3.5"
        },{
            value: 4,
            text: "4"
        },{
            value: 4.5,
            text: "4.5"
        },{
            value: 5,
            text: "5"
        },{
            value: 5.5,
            text: "5.5"
        }],

        
      
    }},
    computed: {
         // 获取select框中所选文本值
                inputValue: function () {
                    const self = this;
                    var value;
 
                    //遍历找到对应文本值
                    this.options.forEach(function (item, index) {
                        if (item.value === self.selectValue) {
                            value = item.text;
                        }
                    });
 
                    return value;
                },
                 inputValue1: function () {
                    const self = this;
                    var value;
 
                    //遍历找到对应文本值
                    this.options.forEach(function (item, index) {
                        if (item.value === self.selectValue1) {
                            value = item.text;
                        }
                    });
 
                    return value;
                }
    },
    created() {
      this.inited = (async () => {
		const apis = [UnitApi.allForMap(),WaterSourceApi.getAll({pointType:1,adminId: this.$route.query.adminId}),UnitApi.dict({p:1000}),UnitFenceApi.index()] 
		const apiReses = await Promise.all(apis) 
        if (apiReses[0].data.status === 0) {
          this.units = apiReses[0].data.data 
        }
        if (apiReses[1].status === 0) {
            this.waterSources = apiReses[1].data
        }
        if (apiReses[2].data.status === 0) {
            this.rankUnits = apiReses[2].data.data
        }
        if (apiReses[3].data.status === 0) {
          this.unitFences = apiReses[3].data.data
          this.$refs.map.drawFences(this.unitFences)
        let water = this.$route.query.water
        if(water) {
          // alert(water)
          this.$refs.map.panTo(water.longitude, water.latitude)
        }
        }
        this.getUserDicts()
        
      })()
    },
    async mounted() {
      const jwtToken = this.$store.getters.loginInfo.jwtToken
      const url = `ws://${window.location.host}/api/web-notify?jwtToken=${jwtToken}`
      //ws.connect(url, this.onWebsocketMessage)

      if (this.inited != undefined) {
        await this.inited 
        delete this.inited
      }
      
      if (this.units) this.$refs.map.markUnits(this.units)
      if (this.waterSources) this.$refs.map.markWaters(this.waterSources)
    },
    beforeRouteLeave (to, from, next) {
      ws.disconnect()
      next()
    },
    methods: {
      changeSelectAdminId() {
        if(this.selectAdminId) {
          //this.$refs.map.clearWaterMap()
        var query = {adminId: this.selectAdminId}
        this.$router.push({path: '/', query: query})
        this.reload() 
        }
      },
      getMapByAdminId(adminId) {
        WaterSourceApi.getAll({pointType:1,adminId: adminId}).then(res=>{
          console.log(res)
          if(res.data) {
            this.waterSources = res.data
            this.$refs.map.markWaters(this.waterSources)
          }

        })
      },
      showWaterImg(showImg) {
        this.showImg = !showImg
        this.$refs.map.waterImgShowOrHide(showImg)
      },
      searchRankUnits() {
      this.loading = true
      UnitApi.dict({q:this.searchRankUnitName,p:1000}).then(resp=>{
        if(resp.data.data && resp.data.data.length > 0) {
          this.$message.success('查询成功，共有'+resp.data.data.length+'条数据')
          this.rankUnits = resp.data.data
        }else{
          this.$message.error('查询不到指定单位')
        }
      })
      this.loading = false
    },
    openUnitFence() {
      this.showFenceTable = true
    },
    handleCloseUnitFenceTable() {
      this.unitFenceId = ''
      this.showFenceTable = false
    },
    getUserDicts() {
        UserApi.dict({roleId: 4}).then(res=>{
          if(res.data.status == 0) {
            if(res.data.data) {
              this.adminTypes = res.data.data
        if(this.$route.query.adminId) {
          this.selectAdminId = this.$route.query.adminId
        }
            }else{
              this.adminTypes = []
            }
          }else{
            this.adminTypes = []
          }
        })
    },
    drawUnitFence() {
      if(!this.unitFenceId) {
        this.$message.error('请先选择需要绘制管辖范围的单位')
        return false
      }
      UnitFenceApi.index({userUnitId: this.unitFenceId}).then(resp=>{
        if(resp.data.data && resp.data.data.length > 0) {
          this.$confirm('当前单位已绘制管辖范围，重新绘制会覆盖原先数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.showFenceTable = false
            this.$refs.map.drawFence(this.unitFenceId)
            this.showWaterImg(false)
            this.clearFenceBtn = true
          }).catch(() => {
                    
          });
        }else {
          
            this.showFenceTable = false
            this.$refs.map.drawFence(this.unitFenceId)
            
            this.showWaterImg(false)
            this.clearFenceBtn = true
        }
      })
      
    },
    clearFence() {
      this.clearFenceBtn = false
      this.$refs.map.clearFence(this.unitFenceId)
      
      this.showWaterImg(false)
      this.unitFenceId = ''
    },
       // input输入修改options中的对应数值
                changeValue: function () {
                    const self = this;
                    var text = this.$refs.inputBox.value;
 
                    //遍历修改对应文本值
                    this.options.forEach(function (item, index) {
                        if (item.value === self.selectValue) {
                            item.text = text;
                        }
                    });
 
                },
                 // input输入修改options中的对应数值
                changeValue1: function () {
                    const self = this;
                    var text = this.$refs.inputBox1.value;
                  
                      this.options.forEach(function (item, index) {
                      
                          if (item.value === self.selectValue1) {
                              item.text = text;
                          }
                      });
                   
 
                },
      makeAlertLabel(alert) {
        alert.alertLabel = `[${alert.alertTime}] ${alert.alertAddress}`
      },
      alertChange(val) {
        this.location = false
      },
      search() {
        //console.log("alert = ", this.alert.alertAddress)
      },
      async changeLocation() { 
        this.location = !this.location
        this.btnIndex = this.location ? 1 : 0
        this.$refs.map.changeLocation(this.location)
      },
      async onLocation(lng, lat) { 
        try {
          await WaterSourceApi.post({ waterSourceId: this.alert.waterSourceId, longitude: lng, latitude: lat, })
        } catch (e) {}
      },
      async addFence(path) { 
        const pathList = []
        for (let i=0;i<path.length;i++) {
            let lng = path[i].lng
            let lat = path[i].lat
            console.log("lng:"+lng+"\n lat:"+lat);
            pathList.push({ unitId: this.unitFenceId, unitGpsX: lng, unitGpsY: lat, })
          }
        try {
          const res = await UnitFenceApi.post(pathList)
          console.log(res)
          if(res.data.status == 0) {
            this.$message.success('绘制成功!')
            this.showWaterImg(true)
            //将电子围栏绘制到地图上
            this.$refs.map.drawPolygon(this.unitFenceId,'新增',path)
          }else{
            this.$message.error('绘制失败，请稍后再试.')
          }
        } catch (e) {
          this.$message.error('绘制失败，请稍后再试.')
        }
      },
      async onFence(value) { 
        this.clearFence()
      },
      async clickLocationAgain() {
        this.loading = true
        try {
          const apiRes = await AlertApi.confirmSms(this.detailItem.alertId)
          if (apiRes.data.status == 0) {
            await this.$alert('发送二次定位短信成功', AppConfig.alertTitle)
          }
        } catch (e) { }
        this.loading = false
      },
      clickDetail() { 
        this.showDetail = true
        this.detailItem = this.alert
      },
      clickNotify() {
        this.loading = false
        this.notifyRadius = 0.5
        this.persons = []
        this.selectPersons = []
        this.showNotify = true
      },
     
      async searchPersons() { 
        this.loading = true

              try {
                const data = (await UserApi.search(this.alert.alertGpsX, this.alert.alertGpsY, this.inputValue * 1000)).data.data
                this.$refs.map.drawCicle(this.inputValue * 1000, data.units, data.users)
                this.persons = this.soredUsers(data.allUsers)
              } catch(e) {
                console.log('exception', e)
              }
              this.loading = false
       
      },
      
      personSelectChange(selection) {
        this.selectPersons = selection
      },
      handleCheck (a, b) {
          //a为传递给 data 属性的数组中该节点所对应的对象；b为树目前的选中状态对象
          if (b.checkedKeys.length > 0) {
            this.$refs.tree.setCheckedKeys([a.id]);
          }
      },
      async sendNotify() {
       
        if (this.selectPersons.length == 0) {
          try { await this.$alert('请先选择人员', AppConfig.alertTitle) } catch (e) {}
          return
        }
      
        try {
          await this.$confirm('是否确定通知所选人员？', AppConfig.alertTitle)
        } catch (e) { return }

        this.loading = true
        try {
          const ids = this.selectPersons.map(v => v.userId)
          try {
            const apiRes = (await PresentApi.notice(this.alert.alertId, ids)).data
            //await this.$alert(Utils.fmt('已成功给{}个用户发送信息', apiRes.data.count), AppConfig.alertTitle)
            await this.$alert('已成功发送警情通知', AppConfig.alertTitle)
          } catch (e) {}
        } finally {
          this.loading = false
        }
      },
      //快捷派警通知方法
      async sendNotify1() {
        
         this.res = this.$refs.tree.getCheckedNodes();
         //await this.$alert(this.res);
         
     

        if (this.res.length == 0) {
          try { await this.$alert('请先选择人员', AppConfig.alertTitle) } catch (e) {}
          return
        }
        var str = "";
       
        for(var sl in this.res){
          var userId = this.res[sl].userId;
          str += userId+ ",";
          
          
        }
        if (str.length > 0) {
            str = str.substr(0, str.length - 1);
         }

       
        try {
          await this.$confirm('是否确定通知所选人员？', AppConfig.alertTitle)
        } catch (e) { return }
        
        this.loading = true
        try {
          const ids = str;
         
         
         
          try {
            const apiRes = (await PresentApi.noticePJ(this.alert.alertId,ids)).data
            //await this.$alert(Utils.fmt('已成功给{}个用户发送信息', apiRes.data.count), AppConfig.alertTitle)
            await this.$alert('已成功发送警情通知', AppConfig.alertTitle)
          } catch (e) {}
        } finally {
          this.loading = false
        }
      },
      async clickStatis() {
        const apiRes = (await PresentApi.alert(this.alert.alertId)).data
        this.presents = apiRes.data
        this.showStatis = true
      },
       clickUnitQuery() {
        this.showUnit = true
        //this.units = []
      },
      async clickSearchUnits() {
        const apiRes = (await WaterSourceApi.getPageList(1,10,{waterSourceName:this.unitQ})).data
        console.log(apiRes)
        if(apiRes) {
          this.searchUnits = apiRes.records
        }else {
          this.$message.info("查询信息为空")
        }
      },
      locationUnit(unit) { 
        this.showUnit = false
        this.$refs.map.panTo(unit.longitude, unit.latitude)
      },
      async clickTrace() { 
        if (this.traceUnits === undefined) await this.onlineChange(false)
        this.showTrace = true
      },
      async clickTracePJ() {
          
       if (this.traceUnitsPJ === undefined) await this.onlineChangePJ(false)
       
        this.showTracePJ = true
      },
      
      loadTrace(node, resolve) { 
        if (node.level === 0) {
          resolve(this.traceUnits)
        } else if (node.level === 1) {
          UserApi.onlineUsers({online: this.online, unitId: node.data.unitId}).then(v => {
            if (v.data.status === 0) {
              for (let item of v.data.data) {
                item.name = item.userName
                item.leaf = true
              }
              resolve(v.data.data)
            } else {
              resolve([])
            }
          })
        }
      },
      loadTracePJ(node, resolve) { 
        if (node.level === 0) {
          resolve(this.traceUnitsPJ)
        } else if (node.level === 1) {
          UserApi.searchUnitPJ({online: this.online, dictName: node.data.dictName}).then(v => {
            if (v.data.status === 0) {
              for (let item of v.data.data) {
                item.name = item.unitName
                item.leaf = true
              }
              resolve(v.data.data)
            } else {
              resolve([])
            }
          })
        }
      },
      async nodeClick(data) { 
        if (data.leaf) { 
          if (!data.isDraw) {
            data.isDraw = true
            const apiRes = (await UserApi.getPosition(data.userId)).data
            if (apiRes.status === 0) {
              if (apiRes.data.userGpsX && apiRes.data.userGpsY) {
                data.userGpsX = apiRes.data.userGpsX
                data.userGpsY = apiRes.data.userGpsY
                this.$refs.map.buildMarker(apiRes.data.userGpsX, apiRes.data.userGpsY, data.userName)
              }
            }
          }
          if (data.userGpsX && data.userGpsY)
            this.$refs.map.panTo(data.userGpsX, data.userGpsY)
        }
      },
     
      async onlineChange(value) { 
        const apiRes = (await UserApi.onlineUnits({online: value})).data
        if (apiRes.status === 0) {
          for (let v of apiRes.data) {
            v.name = v.unitName
            v.leaf = false
          }
          this.traceUnits = apiRes.data
        }
      },
      async onlineChangePJ() { 
        const apiRes = (await UserApi.searchPJ()).data
        if (apiRes.status === 0) {
          for (let v of apiRes.data) {
            v.name = v.dictName
            v.leaf = false
          }
         
          this.traceUnitsPJ = apiRes.data
        }
      },



      onWebsocketMessage(event) {
        const msg = JSON.parse(event.data)
        if (msg.type === 1) {
          if (msg.data.alertId === undefined) return
          if (msg.data.alertId <= this.alerts[0].alertId) return
          this.makeAlertLabel(msg.data)
          this.alerts.pop()
          this.alerts.unshift(msg.data)
          this.alert = msg.data
          let v_msg = this.alert.alertAddress + '发生警情，请立即处理。'
          this.$alert(v_msg, "新警情提示")
          v_msg += v_msg + v_msg
          this.speak(v_msg)
        }
      },
      speak(text) {
        try {
          const utterThis = new window.SpeechSynthesisUtterance(text)
          window.speechSynthesis.speak(utterThis)
        } catch (e) { console.log(e) }
      },
      // 海口消防
      async testwz() {
        const apiRes = await UserApi.notify(this.alert.alertId);
        if (apiRes.data.status == 0) this.termUsers = apiRes.data.data
        this.showTerm = true
      },
      async notifyTerm(id) {
        await PresentApi.notice(this.alert.alertId, [id]);
      },
      displaySearchUserType(value) {
        return this.searchUserTypes[value];
      },
      
      soredUsers(users) {
        if (!users) return users
        const ua = [[], [], [], []]
        for (let u of users)
        ua[u.searchUserType].push(u)
        return [...ua[1], ...ua[0], ...ua[2], ...ua[3]]
      }
      //  soredUsersPJ(users) {
      //   if (!users) return users
      //   const ua = [[], [], [], []]
      //   for (let u of users)
      //     if(u.searchUserType==1){
      //      ua[u.searchUserType].push(u)
      //     }
      //     return [...ua[1], ...ua[0], ...ua[2], ...ua[3]]
       
      // }
    }
  }
</script>





// WEBPACK FOOTER //
// src/pages/home.vue